import React from "react";
import { Route, Redirect, useLocation, useParams } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Spinner } from "../../elements";
import { LOGIN } from "../../../constants";

const propTypes = {
  path: PropTypes.string.isRequired,
  canGetUser: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]),
  // Map state to props
  loggedIn: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  errorLogin: PropTypes.bool.isRequired
};

function PrivateRoute(props) {
  const {
    path,
    canGetUser,
    children,
    // Map state to props
    loggedIn,
    isLoading,
    errorLogin
  } = props;
  const location = useLocation();
  const params = useParams();

  let component = null;
  if (loggedIn) {
    component = <>{children}</>;
  } else if (!canGetUser || errorLogin) {
    component = (
      <Redirect to={`/${params.shortName}/${LOGIN}${location.search}`} />
    );
  }

  return (
    <Route exact path={path}>
      {isLoading ? <Spinner /> : component}
    </Route>
  );
}

PrivateRoute.propTypes = propTypes;

const mapStateToProps = (state) => ({
  loggedIn: state.user.loggedIn,
  isLoading: state.user.isLoading,
  errorLogin: state.user.errorLogin
});

export default connect(mapStateToProps)(PrivateRoute);
